import { EMapBoundsActionType } from './types';
import { IBBoxSchema } from '../../../../node/types/bbox';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Фокусирует карту на области bbox (смена гео): reducer переводит bbox в mapBounds,
 * useBoundsSync применяет setBounds. В отличие от changeBounds не несёт center/zoom,
 * поэтому сам этот экшен queryString (URL) не трогает — URL обновит boundschange
 * (changeBounds с фактическими center/zoom) уже после применения фокуса.
 */
export const focusMapByBbox = actionGenerator<EMapBoundsActionType.FocusedOnBbox, IBBoxSchema>(
  EMapBoundsActionType.FocusedOnBbox,
);
